export class Keyword {
  id!: string;
  keywordName!: string;
  keywordValues!: KeywordValue[];
  preventDelete!: boolean;
  description!: string;
}

export class KeywordValue {
  id!: string;
  keywordValueName!: string;
  description!: string;
}
